import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "primeflex/primeflex.css";
import { FaUsers } from "react-icons/fa";
import { BsClockHistory } from "react-icons/bs";
import { AiOutlineProject } from "react-icons/ai";
import { FaListCheck } from "react-icons/fa6";
import { useSelector } from 'react-redux';
import './SideNav.css';

function SideNav({ isMinimized }) {
  const { userData } = useSelector(state => state?.user);
  const userType = localStorage.getItem('userType');
  const navigate = useNavigate();
  const location = useLocation();

  // Find the user type role safely
  const userTypeRole = userData?.userTypes?.find(type =>
    type?.userType?.toLowerCase().includes(userType?.toLowerCase())
  );

  const menuItemsForEmployee = [
    {
      label: "Timesheets",
      icon: <BsClockHistory size={20} />,
      path: "user/timesheet",
    },
  ];

  const menuItemsForManager = [
    {
      label: "My Timesheets",
      icon: <BsClockHistory size={20} />,
      path: "user/timesheet",
    },
    { label: "Employee Timesheets", icon: <FaUsers size={20} />, path: "user/employees/timesheets" },

  ];
  const menuItemsForOther = [
    { label: "Employee Timesheets", icon: <FaUsers size={20} />, path: "user/employees/timesheets" },
  ]
  const hr = [
    { label: "Employee Timesheets", icon: <BsClockHistory size={20} />, path: "hr/employees/timesheets" },
    { label: "Employees", icon: <FaUsers size={20} />, path: "hr/employee-list" },
    {
      label: "Projects",
      icon: <AiOutlineProject size={20} />,
      path: "hr/project-list",
    },
    {
      label: "Timesheet Summary",
      icon: <FaListCheck size={20} />,
      path: "hr/timesheet-summary",
    },
  ]

  const menuItemsForAdmin = [
    {
      label: "Timesheets",
      icon: <BsClockHistory size={20} />,
      path: "admin/timesheet-list",
    },
    { label: "Employees", icon: <FaUsers size={20} />, path: "admin/employee-list" },
    {
      label: "Projects",
      icon: <AiOutlineProject size={20} />,
      path: "admin/project-list",
    },
    {
      label: "Timesheet Summary",
      icon: <FaListCheck size={20} />,
      path: "admin/timesheet-summary",
    },
  ];
  // Show "My TimeSheet" tab for managers (4) and regular employees (5)
  const employee = userTypeRole ? [5].includes(userTypeRole?.userTypeRoleId) : false;

  // Show "Employee" tab for admin (1), HR (2), account(3) , managers ( 4)
  const manager = userTypeRole ? [4].includes(userTypeRole?.userTypeRoleId) : false;

  const other = userTypeRole ? [3].includes(userTypeRole?.userTypeRoleId) : false;
  const onlyHr = userTypeRole ? [2].includes(userTypeRole?.userTypeRoleId) : false;

  //Show Project to only admin
  const admin = userTypeRole ? [1].includes(userTypeRole?.userTypeRoleId) : false;

  let menuItems;
  // Determine the initial active index
  const getInitialActiveIndex = () => {
    if (employee) return menuItems = menuItemsForEmployee; // Default to My TimeSheet if available
    if (admin) return menuItems = menuItemsForAdmin; //  
    if (other) return menuItems = menuItemsForOther;
    if (onlyHr) return menuItems = hr;
    if (manager) return menuItems = menuItemsForManager; // If My TimeSheet is hidden, Employee becomes index 0
    navigate('/');
    return 0; // Default index
  };

  const [activeIndex, setActiveIndex] = useState(getInitialActiveIndex());

  useEffect(() => {
    setActiveIndex(getInitialActiveIndex());
  }, [employee, manager, admin, userType]);

  const [activeTab, setActiveTab] = useState(location.pathname);

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location.pathname, userType]);

  const handleNavigation = (path) => {
    setActiveTab(path);
    navigate(path);

    // Close sidenav on mobile when menu item is clicked
    if (window.innerWidth <= 1045) {
      const event = new CustomEvent('closeSideNav');
      window.dispatchEvent(event);
    }
  };

  useEffect(() => {
    // if (menuItems && menuItems.length > 0) {
    //   navigate(menuItems[0].path);
    //   setActiveTab(menuItems[0].path);
    // }
  }, []);
  // Ensure activeIndex is set correctly after mounting

  const isPathActive = (menuPath) => {
    const currentPath = location.pathname.toLowerCase();
    const menuPathLower = menuPath.toLowerCase();

    // Handle timesheet routes
    // Handle timesheet routes (own timesheet)
    if (menuPathLower === 'user/timesheet') {
      const isOwnTimesheet =
        currentPath === '/user/timesheet' ||
        currentPath === '/user/add-timesheet' ||
        currentPath.startsWith('/user/edit-timesheet')|| currentPath.startsWith('/user/self-timesheet');
      return isOwnTimesheet;
    }


    // Handle employee timesheet routes (viewing someone else's timesheet)
    if (menuPathLower.includes('user/employees')) {
      const isViewingEmployeeTimesheet =
        /^\/user\/timesheet\/[^/]+$/.test(currentPath) && // matches /user/timesheet/:id
        !currentPath.includes('/user/edit-timesheet');
      return currentPath.includes('user/employees') || isViewingEmployeeTimesheet;
    }

    // Handle admin timesheet routes
    if (menuPathLower.includes('admin/timesheet-list')) {
      return currentPath.includes('admin/timesheet-list') ||
        currentPath.includes('admin/timesheet/') ;
    }
    //Handle Hr routes
       if (menuPathLower.includes('hr/employees')) {
        return currentPath.includes('hr/employees') ||
          currentPath.includes('hr/timesheet/');
      }
  
  
    
    // Handle project routes
    if (menuPathLower.includes('project-list') && currentPath.includes('/project/')) {
      return true;
    }

    // Handle employee routes
    if (menuPathLower.includes('employee-list') && currentPath.includes('/employee/')) {
      return true;
    }


    return currentPath.includes(menuPathLower);
  };

  return (
    <div className="h-screen smallScreen pt-3 side-nav-content">

      {menuItems?.map((item) => (
        <div
          key={item.path}
          className={`flex align-items-center p-1 cursor-pointer transition-colors transition-duration-150 mx-1 mb-2
            `}
          onClick={() => handleNavigation(item.path)}
        >
          <div className={`flex align-items-center border-round-3xl w-full ${isPathActive(item?.path)
              ? `bg-red-500 text-white font-medium ${isMinimized ? 'p-2' : 'xl:pl-4 xl:pr-4 p-2'} shadow-1`
              : `hover:surface-200 ${isMinimized ? 'p-2' : 'xl:pl-4 p-2'}`
            }`}>
            <span className={`flex align-items-center justify-content-center ${isMinimized ? 'w-full' : ''} ${isPathActive(item?.path) ? "text-white" : "text-700"}`}>
              {item?.icon}
            </span>
            {!isMinimized && (
              <div className="ml-2 overflow-hidden flex-1">
                <span className="text-overflow-ellipsis overflow-hidden white-space-nowrap block w-full sidenav-label">
                  {item?.label}
                </span>
              </div>
            )}
          </div>

        </div>
      ))}
    </div>
  );
}

export default SideNav;
